export const ETFTOKEN = 'ETFTOKEN'
export const ETFTOKEN_RESPONSE = 'ETFTOKEN_RESPONSE'
export const ETFTOKEN_RESPONSE_FAIL = 'ETFTOKEN_RESPONSE_FAIL'

export const ETFTRANSACTIONID = 'ETFTRANSACTIONID'
export const ETFTRANSACTIONID_RESPONSE = 'ETFTRANSACTIONID_RESPONSE'
export const ETFTRANSACTIONID_RESPONSE_FAIL = 'ETFTRANSACTIONID_RESPONSE_FAIL'

export const GETTICKERCODE = 'GETTICKERCODE'
export const GETTICKERCODE_RESPONSE = 'GETTICKERCODE_RESPONSE'
export const GETTICKERCODE_RESPONSE_FAIL = 'GETTICKERCODE_RESPONSE_FAIL'